import { FOUNDER } from "@/data/founder";

/**
 * Renders the founder-letter body blocks in an editorial serif column.
 * Shared by both <FounderNote /> (the site-wide callout) and the
 * FounderStory page at /about/founder.
 */
export default function FounderBody({ blocks = [] }) {
  return (
    <div className="max-w-[62ch] text-[color:var(--np-text-2,#3A3830)]">
      {blocks.map((b, i) => {
        if (b.type === "h2") {
          return (
            <h3
              key={i}
              className="font-serif-display text-2xl md:text-3xl leading-tight tracking-tight text-[color:var(--np-text,#1B4332)] mt-10 first:mt-0"
            >
              {b.text}
            </h3>
          );
        }
        if (b.type === "p") {
          return (
            <p key={i} className="mt-4 text-[15.5px] md:text-[16.5px] leading-[1.75]">
              {b.text}
            </p>
          );
        }
        if (b.type === "ul") {
          return (
            <ul key={i} className="mt-5 space-y-1.5 list-disc pl-6 text-[15.5px] md:text-[16.5px] leading-[1.7]">
              {b.items.map((li, j) => <li key={j}>{li}</li>)}
            </ul>
          );
        }
        if (b.type === "pullquote") {
          return (
            <blockquote
              key={i}
              className="mt-8 mb-2 pl-5 border-l-2 border-[color:var(--np-brand,#B85F2A)] font-serif-display text-xl md:text-2xl leading-snug italic text-[color:var(--np-text,#1B4332)]"
            >
              {b.text}
            </blockquote>
          );
        }
        if (b.type === "signoff") {
          return (
            <div key={i} className="mt-12 border-t border-black/10 pt-8">
              <div className="font-serif-display text-lg text-[color:var(--np-text,#1B4332)]">
                {FOUNDER.name}
              </div>
              <div className="mt-0.5 font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[color:var(--np-brand,#B85F2A)]">
                {FOUNDER.role}
              </div>
              <p className="mt-5 font-serif-display text-lg md:text-xl italic leading-snug text-[color:var(--np-text,#1B4332)]">
                NaturePulse.net — Documenting the pulse of our living planet, one observation at a time.
              </p>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}
